"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CardHeader = _interopRequireDefault(require("./CardHeader"));
var _CardStandard = _interopRequireDefault(require("./CardStandard"));
var _CardMedia = _interopRequireDefault(require("./CardMedia"));
const cardType = {
  Header: _CardHeader.default,
  Standard: _CardStandard.default,
  Video: _CardMedia.default,
  Image: _CardMedia.default
};
const CardSwitcher = ({
  card,
  style
}) => {
  const Card = cardType[card.type];
  return /*#__PURE__*/_react.default.createElement(Card, {
    card: card,
    style: style
  });
};
CardSwitcher.propTypes = {
  style: _propTypes.default.object,
  card: _propTypes.default.shape({
    type: _propTypes.default.oneOf(['Standard', 'Header', 'Video', 'Image']).isRequired,
    tag: _propTypes.default.string,
    title: _propTypes.default.string,
    leftImage: _propTypes.default.string,
    rightImage: _propTypes.default.string,
    description: _propTypes.default.string,
    disableContentCenter: _propTypes.default.bool,
    url: _propTypes.default.string,
    videoCaptionsFile: _propTypes.default.string,
    videoCaptionsFileLocale: _propTypes.default.string,
    videoCaptionsFileLang: _propTypes.default.string,
    videoPoster: _propTypes.default.string,
    iconColor: _propTypes.default.string,
    rtbItemsArray: _propTypes.default.arrayOf(_propTypes.default.string),
    itemsCenter: _propTypes.default.bool,
    iconComponent: _propTypes.default.elementType,
    isMobile: _propTypes.default.bool,
    containerclassName: _propTypes.default.string
  }).isRequired
};
var _default = exports.default = CardSwitcher;